import axios from 'axios'

import {
  TestResult,
  DataLeaksDetails,
  CategoryData,
  CategoryResult,
} from '../types'

import { getPassedTestsCount } from '../utils'

/* ------------------------------ 🗿 Constants ------------------------------ */

const testsDetails: DataLeaksDetails[] = [
  {
    payload:
      '001-02-3122, 856-45-6789, 648-12-3142, 123-53-1974, 851-23-3132, 001023122, 856-45-6789, 648 12 3142, 008-48-5156, 223-29-0659, 002-30-5555',
    title: 'SSN codes',
    description: 'SSN_CODES'
  },
  {
    payload:
      '5090109468008, 1990401469766, 1470831469087, 2860212229619, 6020613025162, 2920613086328, 2820613515411, 1820613317594, 1540811177205, 1840911066589, 2850911059130',
    title: 'Local Country SSN codes',
    description: 'LOCAL_SSN_CODES'
  },
  {
    payload:
      '4580-0000-0000-0000, 5500 0000 0000 0004, 4024 0071 0007 2775, 4024007117885730, 4024007186169115',
    title: 'Credit card numbers',
    description: 'CREDIT_CARD'
  },
  {
    payload:
      '#include <iostream.h>\r\n#include "functions.h"\r\nint main(){\r\nprint_hello();\r\ncout << endl;\r\ncout << "The factorial of 5 is " << factorial(5) << endl;\r\nreturn 0;\r\n}\r\n',
    title: 'Source code (C)',
    description: 'SOURCE_CODE'
  },
  {
    payload:
      '-----BEGIN RSA PRIVATE KEY-----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-----END RSA PRIVATE KEY-----',
    title: 'SSH private key',
    description: 'SSH_KEY'
  },
]

/* -------------------------- 💼 Category functions ------------------------- */

export function getDataProtectionInitial(): CategoryData {
  return {
    title: 'Data Protection',
    description:
      'Data protection is in this case pointing to either Personal/Private Information that can constitute a breach of GDPR or other regualtions, Intellectual Property such as Code [relevant for Software Development Companies] or Restricted information that can lead to the compromise of Machines within the organization such as passwords or key files.',
    tests: [],
    passedTestsCount: 0,
    generalTitle: 'The information should only be used lawfuly and fairly',
    generalDescription:
      'Data is factual information used as a basis for other processes. Digital data [Computer Data] is the same kind of information contained on informatic systems. Personal information is a special kind of data that needs to be used keeping "Data protection principles" in mind. The information should only be used lawfuly and fairly, for a specified purpose, limited to what is strictly necessary, kept accurate and to date and not for a longer time than needed. It also needs to be handled in a way that ensures appropriate security.',
    businessTitle:
      'Data Protection controls how this digital information is used',
    businessDescription:
      "Data Protection controls how this digital information is used, it's integrity and most importantly who has access to the data.",
    impactTitle: 'There are strong regulations in place such as CCPA or GDPR',
    impactDescription:
      'Breach of personal data may cause damage to both tshe owner of this and the company leaking this information. There are strong regulations in place such as California Consumer Privacy Act or GDPR that come with consistent fines.',
    article: {
      title:
        'Why Employers Need To Pay Attention Right Now To California’s Consumer Privacy Law',
      summary:
        'California lawmakers passed a landmark privacy act in 2018 that provides sweeping new protections for consumers, and wades into territory covered by the European Union’s far-reaching General Data Protection Regulation, or GDPR. Called “GDPR Lite” by some, the California Consumer Privacy Act, or CCPA, gives consumers the right to know what personal information is being collected, how it will be used, and whether it will be traded, bought, sold or reused. With it, consumers also can have their personal information deleted and exempted from sale.',
      image: 'https://miro.medium.com/max/1000/1*uXCejaU_85K6KWinjPWXKw.png',
      url:
        'https://www.forbes.com/sites/alonzomartinez/2019/11/08/why-employers-need-to-pay-attention-right-now-to-californias-consumer-privacy-law/',
      date: 'Nov 8, 2019',
    },
  }
}

export const getDataProtectionResult = async (
  host: string,
  isRunningViaHTTPS: boolean
): Promise<CategoryResult> => {
  let tests = []

  if (isRunningViaHTTPS) {
    tests = await Promise.all(
      testsDetails.flatMap((test) => [checkDataLeakBlock('https', host, test)])
    )
  } else {
    tests = await Promise.all(
      testsDetails.flatMap((test) => [
        checkDataLeakBlock('https', host, test),
        checkDataLeakBlock('http', host, test),
      ])
    )
  }

  return {
    title: 'Data Protection',
    tests,
    passedTestsCount: getPassedTestsCount(tests),
  }
}

/* --------------------------- 📄 Tests functions --------------------------- */

async function checkDataLeakBlock(
  protocol: 'http' | 'https',
  host: string,
  details: DataLeaksDetails
): Promise<TestResult> {
  const testDetails: TestResult = {
    title: `${details.title} leak via ${protocol}`,
    description: details.description,
    passed: true,
  }

  const plainTextConfig = {
    headers: {
      'Content-Type': 'text/plain',
    },
  }

  try {
    await axios.post(
      `${protocol}://${host}/api/echo/`,
      { data: details.payload },
      { timeout: 15000 }
    )

    await axios.post(
      `${protocol}://${host}/api/echo/`,
      { data: details.payload },
      { ...plainTextConfig, timeout: 15000 }
    )

    return { ...testDetails, passed: false }
  } catch (e) {
    return testDetails
  }
}
